import { Section, DataTable, Kpi, pctFmt } from "./_shared";
import { BarChartC } from "../_charts";

export default function OmniAi({ data }) {
  const t = data.totals || {};
  return (
    <div className="space-y-4" data-testid="omni-ai">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        <Kpi label="Bot handled" value={t.bot_handled} testid="omni-ai-bot-handled" />
        <Kpi label="Bot resolved" value={t.bot_resolved} testid="omni-ai-bot-resolved" />
        <Kpi label="Bot containment" value={`${t.containment_rate ?? 0}%`} testid="omni-ai-containment" />
        <Kpi label="Escalated to agent" value={t.escalated} hint={`${t.escalation_rate ?? 0}% of bot chats`} testid="omni-ai-escalated" />
        <Kpi label="Agent handled" value={t.agent_handled} testid="omni-ai-agent-handled" />
        <Kpi label="Knowledge gaps" value={t.kb_gaps} hint="Questions the bot couldn't answer" testid="omni-ai-kb-gaps" />
      </div>
      <Section title="Bot vs agent by channel" testid="omni-ai-chart">
        <BarChartC data={data.rows || []} xKey="channel" yKeys={[
          { id: "bot_handled", label: "Bot handled" }, { id: "bot_resolved", label: "Bot resolved" },
          { id: "escalated", label: "Escalated" }, { id: "agent_handled", label: "Agent handled" }]} />
      </Section>
      <Section title="By channel" testid="omni-ai-table-card">
        <DataTable columns={data.columns} rows={data.rows || []} testid="omni-ai-table"
          format={{ containment_rate: pctFmt, escalation_rate: pctFmt }} />
      </Section>
      <Section title="Top escalation reasons" testid="omni-ai-reasons-card">
        <DataTable columns={[{ id: "reason", label: "Reason" }, { id: "count", label: "Conversations" }]}
          rows={data.escalation_reasons || []} testid="omni-ai-reasons" empty="No escalations in this range." />
      </Section>
    </div>
  );
}
